var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list',{staticClass:"pa-0"},_vm._l((_vm.providersToDisplay),function(provider,index){return _c('app-common-api-health-item',{key:index,attrs:{"provider":provider,"layout":_vm.layout}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }